// extracted by mini-css-extract-plugin
export default {"root":"root___wPSAq","iconContainer":"iconContainer___cwH4M","icon":"icon___dswxR","text":"text___pMMrh"};